/**
 * ============================================================================
 * TRANSIENT: Appointment Config Page (appointment-config-page)
 * Type: poc
 * Amplitude key: none
 * End date: 2026-12-31
 * PR: #TODO_AFTER_PR_CREATION_appointment-config-page
 * ============================================================================
 */

import { Box, Button, Typography } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

type Props = {
    onConnect: () => void;
};

export const AppointmentDisconnectedStatePartial = ({ onConnect }: Props): JSX.Element => {
    const { formatMessage } = useIntl();

    return (
        <Box
            data-spec-id="agenda-disconnected-state"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                gap: 2,
                p: 4,
            }}
        >
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                {formatMessage({ id: 'appointment.disconnected.title' })}
            </Typography>
            <Typography
                variant="body2"
                sx={{ color: 'text.secondary', maxWidth: 480, textAlign: 'center' }}
            >
                {formatMessage({ id: 'appointment.disconnected.description' })}
            </Typography>
            <Button
                data-spec-id="agenda-connect-google-button"
                variant="contained"
                onClick={onConnect}
            >
                {formatMessage({ id: 'appointment.disconnected.connect_button' })}
            </Button>
        </Box>
    );
};
